<script lang="ts">
    import { getDBEntry } from "../api"
    import { spaNavigate } from "../lib/actions"
    import CardWrapper from "../lib/components/CardWrapper.svelte"
    import Cta from "../lib/components/CTA.svelte"
    import Loader from "../lib/components/Loader.svelte"
    import Modal from "../lib/components/Modal.svelte"
    import { isMobile, login, rerenderSteps } from "../lib/store"
    import TaskProtocol from "../lib/taskSteps/protocol/TaskProtocol.svelte"
    import TaskGenerelStep from "../lib/taskSteps/TaskGenerelStep.svelte"
    import TaskSteps from "../lib/taskSteps/TaskSteps.svelte"
    import MainModalLowerLine from "../lib/taskSteps/widgets/MainModalLowerLine.svelte"

    export let taskId: string
    let task: TaskOilSpillRemoval | TaskTowing
    async function loadData(dummy: any) {
        // @ts-ignore
        task = await getDBEntry("task", {
            _id: taskId,
        })
    }
    loadData(null)
    let visibleModals = {
        protocol: false,
    }
    let forceRerender = 0

    $: loadData($rerenderSteps).then(() => {
        forceRerender = Math.random()
    })
</script>

<section class="actions wrapper">
    <div style="display: flex; width: 100%; justify-content: space-between; margin-bottom: 0px !important;">
        <Cta
            type="BubbleButton"
            icon="solar_arrow-left-outline"
            content="{$isMobile ? 'Auftrag' : 'zurück zur Übersicht des Auftrags'}"
            on:click="{() => {
                spaNavigate('/order/' + task.orderId)
            }}"
        />
        {#if $login.user.roles.includes("admin")}
            <button
                class="gray"
                on:click="{() => {
                    visibleModals.protocol = true
                }}"
            >
                <img
                    alt="icon"
                    src="../../assets/icons/solar_sort-by-time-outline-white.svg"
                />
            </button>
        {/if}
    </div>
</section>

<section class="task-detailed wrapper">
    {#if task}
        <CardWrapper
            icon="{task && task.taskType === 'oilSpillRemoval'
                ? 'solar_waterdrops-outline.svg'
                : 'solar_tow-truck.svg'}"
            title="{task.generalDetails.shortDescription}"
        >
            {#key forceRerender}
                {#if task}
                    <TaskGenerelStep task="{JSON.parse(JSON.stringify(task))}" />
                    <TaskSteps
                        task="{JSON.parse(JSON.stringify(task))}"
                        on:claimStep="{() => {
                            $rerenderSteps += 1
                        }}"
                    />
                {/if}
            {/key}
        </CardWrapper>
    {:else}
        <Loader />
    {/if}
</section>

{#if visibleModals.protocol && !!task}
    <Modal
        show="{true}"
        mainModal="{true}"
        showCloseIcon="{true}"
        size="xl"
        on:close="{() => {
            visibleModals.protocol = false
        }}"
    >
        <div
            slot="header"
            class="inner-modal-header"
        >
            <div class="upper">
                <div class="title">
                    <img
                        src="../../assets/icons/solar_sort-by-time-outline-white.svg"
                        alt="icon"
                    />
                    <p>Einsatzhistorie</p>
                </div>
            </div>

            <MainModalLowerLine task="{JSON.parse(JSON.stringify(task))}" />
        </div>
        <div class="wrapper">
            <TaskProtocol task="{JSON.parse(JSON.stringify(task))}" />
        </div>
        <div
            class="inner-footer"
            slot="footer"
            style="justify-content: flex-end;"
        >
            <div></div>
            <div>
                <Cta
                    type="primaryButton"
                    icon="solar_close-circle-outline"
                    content="Schließen"
                    on:click="{(e) => {
                        visibleModals.protocol = false
                    }}"
                />
            </div>
        </div>
    </Modal>
{/if}

<style lang="less">
    .actions {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 0.6rem;
    }
    .task-detailed {
        position: relative;
        display: flex;
        width: 100%;
        margin: 2.4rem 0px;
    }
    button.gray {
        display: flex;
        padding: 6px;
        align-items: flex-start;
        gap: 10px;
        border-radius: 36px;
        background: var(--text-100);
        width: fit-content;
    }
</style>
